import { cn } from "@newxsystems/shared";
import type { IWohaRichTextProps } from "./WohaRichText.props";
export const WohaRichText = ({ className, content }: IWohaRichTextProps) => (
  <div
    className={cn(
      "[&_a]:text-electric-blue [&_a]:underline [&_a]:underline-offset-4 [&_blockquote]:border-l [&_blockquote]:border-ash [&_blockquote]:pl-5 [&_li]:my-1 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-4 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-6",
      className,
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);
WohaRichText.displayName = "Content::WohaRichText";
